<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Tax Breakdown By Day" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'financeReport', label: 'Finance' },
        {
          name: 'salesTaxBreakdownDay',
          label: 'Tax Breakdown By Day',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
        :percentage="percentageCompleted" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr>
                <th align="left">Date</th>
                <th align="right">Total Sales</th>
                <th align="right">Cannabis Gross</th>
                <th align="right">Cannabis Tax</th>
                <th align="right">Cannabis Net</th>
                <th align="right">Other Gross</th>
                <th align="right">Other Tax</th>
                <th align="right">Other Net</th>
              </tr>
            </thead>

            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="[date, value] in Object.entries(reportData.list)" :key="date">
                <td>{{ value.dateString }}</td>
                <td align="right">{{ Utilities.formatPrice(value.total) }}</td>
                <td align="right">
                  {{ Utilities.formatPrice(value.cannabisGross) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(value.cannabisTax) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(value.cannabisNet) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(value.otherGross) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(value.otherTax) }}
                </td>
                <td align="right">
                  {{ Utilities.formatPrice(value.otherNet) }}
                </td>
              </tr>
            </tbody>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
            <tr>
              <td>Totals</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.total) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.cannabisGross) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.cannabisTax) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.cannabisNet) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.otherGross) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.otherTax) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.otherNet) }}
              </td>
            </tr>
            <tr class="skip-export"></tr>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import ReportHelper from "@/lib/report/index.js";

export default {
  data() {
    return {
      Utilities,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Tax Breakdown By Day");
  },
  computed: {
    ...mapGetters({
      isLoading: "reports/isLoading",
      getData: "reports/getData",
      percentageCompleted: 'reports/percentageCompleted'
    }),
    reportData() {
      return this.getData;
    },
  },
  methods: {
    ...mapActions({
      generateReport: "reports/generate",
      clearData: "reports/clearData",
    }),
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "salesTaxBreakdownDay");
    },
    performGetReport(filter) {
      let reportType = "salesTaxBreakdownDay";
      this.generateReport({
        reportType,
        ...filter,
      });
    },
  },
  beforeDestroy() {
    this.clearData()
  }
};
</script>

<style lang="scss">
@import "./_salesTaxBreakdownDay.scss";
</style>
